/** Target object count for auto-populated 3D factory layouts. */
export const LAYOUT_3D_OBJECT_COUNT = 10_000;

/** Below this count, every element uses a detailed mesh (small demo layouts). */
export const SMALL_DETAILED_MESH_LIMIT = 40;

/** Below this count, JSON-imported layouts use detailed meshes instead of instancing. */
export const DIRECT_3D_MESH_LIMIT = 600;

export const LAYOUT_3D_CACHE_PREFIX = 'layout3d-cache:';

export const LAYOUT_3D_JSON_VERSION = '1.1.0-floor-only';
